<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div class="header-side"></div>
    <div class="dialog-title-text" cdkDragHandle>
      Existing Streams
    </div>
    <button mat-icon-button class="close-btn" (click)="closeModal()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <form id="MaterialStreamForm" #streamForm="ngForm" (ngSubmit)="saveStreamData()">
    <mat-dialog-content class="mat-typography">
      <div >
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Stream</mat-label>
          <mat-select [(ngModel)]="selectedStreamId" name="streamSelect" #streamSelect="ngModel" required >
              <div class="mat-select-search-container" (click)="$event.stopPropagation()">
                <input #sgSearchInput matInput placeholder="Search Streams..." (input)="filterStreams($event)"
                        class="mat-select-search-input" aria-label="Search Streams"  (keydown)="$event.stopPropagation();" />
                <mat-icon class="mat-select-search-icon">search</mat-icon>
              </div>
              <mat-option [value]="null">Select Stream</mat-option>
              <mat-option *ngFor="let stream of filteredExistingStreams" [value]="stream.id">
              {{ stream.name }}
              </mat-option>
          </mat-select>
          <mat-error *ngIf="streamSelect.invalid && (streamSelect.touched || streamForm.submitted)">
            Please select a stream
          </mat-error>
        </mat-form-field>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="dialog-footer">
      <button (click)="closeModal()" type="button" mat-raised-button color="primary">
        Cancel
      </button>
      <button type="submit" mat-raised-button color="primary">
        Save
      </button>
    </mat-dialog-actions>
  </form>